module.exports = __webpack_public_path__ + "static/img/01037D_1_R_201990227_fit.9711e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01037D_1_R_201990227_fit.png
// module id = CiKh
// module chunks = 0